import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { NbAuthService } from '@nebular/auth';

export interface DjangoAuthResponse {
  access_token: string;
  refresh_token: string;
}

export interface DjangoAuthResponseWrapper {
  token: DjangoAuthResponse;
}

@Injectable({
  providedIn: 'root'
})
export class AzureAuthService {
  private tokenEndpoint = `${environment.azureAuth.authority}/oauth2/v2.0/token`;

  constructor(
    private http: HttpClient
  ) {}

  exchangeCodeForToken(code: string): Observable<any> {
    const verifier = sessionStorage.getItem('pkce_verifier');
    if (!verifier) {
      throw new Error('PKCE verifier not found in session storage.');
    }

    const payload = new URLSearchParams({
        client_id: environment.azureAuth.clientId,
        scope: 'openid profile email User.Read',
        code: code,
        redirect_uri: environment.azureAuth.redirectUri,
        grant_type: 'authorization_code',
        code_verifier: verifier
    });

    return this.http.post<any>(this.tokenEndpoint, payload.toString(), {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    });
  }
}
